import api from "./withAuth";

const getPayments = async () => {
   return await api.get("payments");
};

export const paymentsAPI = {
   getPayments,
};
